export default __webpack_public_path__ + "static/media/MOBX.a15d71d8.png";